import { render, staticRenderFns } from "./CardNotice.vue?vue&type=template&id=2dfdc46b&scoped=true&"
import script from "./CardNotice.vue?vue&type=script&lang=js&"
export * from "./CardNotice.vue?vue&type=script&lang=js&"
import style0 from "./CardNotice.vue?vue&type=style&index=0&id=2dfdc46b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfdc46b",
  null
  
)

export default component.exports